import { PromiseDelegate } from '@lumino/coreutils';
import { Signal } from '@lumino/signaling';
import { PageConfig, URLExt } from '@jupyterlab/coreutils';
import { WORKER_NAME } from './tokens';
export class ServiceWorkerManager {
    constructor() {
        this._registration = null;
        this._registrationChanged = new Signal(this);
        this._ready = new PromiseDelegate();
        void this.initialize().catch(console.warn);
    }
    /**
     * A signal emitted when the registration changes.
     */
    get registrationChanged() {
        return this._registrationChanged;
    }
    /**
     * Whether the ServiceWorker is enabled or not.
     */
    get enabled() {
        return this._registration !== null;
    }
    get ready() {
        return this._ready.promise;
    }
    async initialize() {
        const { serviceWorker } = navigator;
        const workerUrl = URLExt.join(PageConfig.getBaseUrl(), WORKER_NAME);
        let registration = null;
        if (!serviceWorker) {
            console.warn('ServiceWorkers not supported in this browser');
        }
        else if (serviceWorker.controller) {
            registration =
                (await serviceWorker.getRegistration(serviceWorker.controller.scriptURL)) ||
                    null;
            console.info('JupyterLite ServiceWorker was already registered');
        }
        if (!registration && serviceWorker) {
            try {
                console.info('Registering new JupyterLite ServiceWorker', workerUrl);
                registration = await serviceWorker.register(workerUrl);
                console.info('JupyterLite ServiceWorker was sucessfully registered');
            }
            catch (err) {
                console.warn(err);
                console.warn(`JupyterLite ServiceWorker registration unexpectedly failed: ${err}`);
            }
        }
        this.setRegistration(registration);
        if (!registration) {
            this._ready.reject(void 0);
        }
        else {
            this._ready.resolve(void 0);
        }
    }
    setRegistration(registration) {
        this._registration = registration;
        this._registrationChanged.emit(this._registration);
    }
}
//# sourceMappingURL=service-manager.js.map